module.exports = __webpack_public_path__ + "static/media/news-fallback.ff733218.webp";